import SuisseIntlBlackWebXL from '../assets/fonts/SuisseIntl/SuisseIntl-Black-WebXL.woff2';
import SuisseIntlBlackItalicWebXL from '../assets/fonts/SuisseIntl/SuisseIntl-BlackItalic-WebXL.woff2';
import SuisseIntlBoldWebXL from '../assets/fonts/SuisseIntl/SuisseIntl-Bold-WebXL.woff2';
import SuisseIntlBoldItalicWebXL from '../assets/fonts/SuisseIntl/SuisseIntl-BoldItalic-WebXL.woff2';
import SuisseIntlBookWebXL from '../assets/fonts/SuisseIntl/SuisseIntl-Book-WebXL.woff2';
import SuisseIntlBookItalicWebXL from '../assets/fonts/SuisseIntl/SuisseIntl-BookItalic-WebXL.woff2';
import SuisseIntlLightWebXL from '../assets/fonts/SuisseIntl/SuisseIntl-Light-WebXL.woff2';
import SuisseIntlLightItalicWebXL from '../assets/fonts/SuisseIntl/SuisseIntl-LightItalic-WebXL.woff2';
import SuisseIntlMediumWebXL from '../assets/fonts/SuisseIntl/SuisseIntl-Medium-WebXL.woff2';
import SuisseIntlMediumItalicWebXL from '../assets/fonts/SuisseIntl/SuisseIntl-MediumItalic-WebXL.woff2';
import SuisseIntlRegularWebXL from '../assets/fonts/SuisseIntl/SuisseIntl-Regular-WebXL.woff2';
import SuisseIntlRegularItalicWebXL from '../assets/fonts/SuisseIntl/SuisseIntl-RegularItalic-WebXL.woff2';
import SuisseIntlSemiBoldWebXL from '../assets/fonts/SuisseIntl/SuisseIntl-SemiBold-WebXL.woff2';
import SuisseIntlSemiBoldItalicWebXL from '../assets/fonts/SuisseIntl/SuisseIntl-SemiBoldItalic-WebXL.woff2';
import SuisseIntlThinWebXL from '../assets/fonts/SuisseIntl/SuisseIntl-Thin-WebXL.woff2';
import SuisseIntlThinItalicWebXL from '../assets/fonts/SuisseIntl/SuisseIntl-ThinItalic-WebXL.woff2';
import SuisseIntlUltralightWebXL from '../assets/fonts/SuisseIntl/SuisseIntl-Ultralight-WebXL.woff2';
import SuisseIntlUltralightItalicWebXL from '../assets/fonts/SuisseIntl/SuisseIntl-UltralightItalic-WebXL.woff2';

export const BaseStyles = [
  {
    '@font-face': {
      fontFamily: 'Suisse Intl',
      fontStyle: 'normal',
      fontWeight: 900,
      fontDisplay: 'swap',
      src: `url(${SuisseIntlBlackWebXL}) format('woff2')`,
    },
  },

  {
    '@font-face': {
      fontFamily: 'Suisse Intl',
      fontStyle: 'italic',
      fontWeight: 900,
      fontDisplay: 'swap',
      src: `url(${SuisseIntlBlackItalicWebXL}) format('woff2')`,
    },
  },

  {
    '@font-face': {
      fontFamily: 'Suisse Intl',
      fontStyle: 'normal',
      fontWeight: 700,
      fontDisplay: 'swap',
      src: `url(${SuisseIntlBoldWebXL}) format('woff2')`,
    },
  },

  {
    '@font-face': {
      fontFamily: 'Suisse Intl',
      fontStyle: 'italic',
      fontWeight: 700,
      fontDisplay: 'swap',
      src: `url(${SuisseIntlBoldItalicWebXL}) format('woff2')`,
    },
  },

  {
    '@font-face': {
      fontFamily: 'Suisse Intl',
      fontStyle: 'normal',
      fontWeight: 800,
      fontDisplay: 'swap',
      src: `url(${SuisseIntlBookWebXL}) format('woff2')`,
    },
  },

  {
    '@font-face': {
      fontFamily: 'Suisse Intl',
      fontStyle: 'italic',
      fontWeight: 800,
      fontDisplay: 'swap',
      src: `url(${SuisseIntlBookItalicWebXL}) format('woff2')`,
    },
  },

  {
    '@font-face': {
      fontFamily: 'Suisse Intl',
      fontStyle: 'normal',
      fontWeight: 300,
      fontDisplay: 'swap',
      src: `url(${SuisseIntlLightWebXL}) format('woff2')`,
    },
  },

  {
    '@font-face': {
      fontFamily: 'Suisse Intl',
      fontStyle: 'italic',
      fontWeight: 300,
      fontDisplay: 'swap',
      src: `url(${SuisseIntlLightItalicWebXL}) format('woff2')`,
    },
  },

  {
    '@font-face': {
      fontFamily: 'Suisse Intl',
      fontStyle: 'normal',
      fontWeight: 500,
      fontDisplay: 'swap',
      src: `url(${SuisseIntlMediumWebXL}) format('woff2')`,
    },
  },

  {
    '@font-face': {
      fontFamily: 'Suisse Intl',
      fontStyle: 'italic',
      fontWeight: 500,
      fontDisplay: 'swap',
      src: `url(${SuisseIntlMediumItalicWebXL}) format('woff2')`,
    },
  },

  {
    '@font-face': {
      fontFamily: 'Suisse Intl',
      fontStyle: 'normal',
      fontWeight: 400,
      fontDisplay: 'swap',
      src: `url(${SuisseIntlRegularWebXL}) format('woff2')`,
    },
  },

  {
    '@font-face': {
      fontFamily: 'Suisse Intl',
      fontStyle: 'italic',
      fontWeight: 400,
      fontDisplay: 'swap',
      src: `url(${SuisseIntlRegularItalicWebXL}) format('woff2')`,
    },
  },

  {
    '@font-face': {
      fontFamily: 'Suisse Intl',
      fontStyle: 'normal',
      fontWeight: 600,
      fontDisplay: 'swap',
      src: `url(${SuisseIntlSemiBoldWebXL}) format('woff2')`,
    },
  },

  {
    '@font-face': {
      fontFamily: 'Suisse Intl',
      fontStyle: 'italic',
      fontWeight: 600,
      fontDisplay: 'swap',
      src: `url(${SuisseIntlSemiBoldItalicWebXL}) format('woff2')`,
    },
  },

  {
    '@font-face': {
      fontFamily: 'Suisse Intl',
      fontStyle: 'normal',
      fontWeight: 100,
      fontDisplay: 'swap',
      src: `url(${SuisseIntlThinWebXL}) format('woff2')`,
    },
  },

  {
    '@font-face': {
      fontFamily: 'Suisse Intl',
      fontStyle: 'italic',
      fontWeight: 100,
      fontDisplay: 'swap',
      src: `url(${SuisseIntlThinItalicWebXL}) format('woff2')`,
    },
  },

  {
    '@font-face': {
      fontFamily: 'Suisse Intl',
      fontStyle: 'normal',
      fontWeight: 200,
      fontDisplay: 'swap',
      src: `url(${SuisseIntlUltralightWebXL}) format('woff2')`,
    },
  },

  {
    '@font-face': {
      fontFamily: 'Suisse Intl',
      fontStyle: 'italic',
      fontWeight: 200,
      fontDisplay: 'swap',
      src: `url(${SuisseIntlUltralightItalicWebXL}) format('woff2')`,
    },
  },
];
